import { primaryColorLanding } from "assets/jss/material-kit-pro-react";
import { subtitleLandingBold } from "assets/jss/material-kit-pro-react";
import { PrimaryFontColorLanding } from "assets/jss/material-kit-pro-react";

const style = (theme) => ({
  container: {
    paddingRight: "180px",
    paddingLeft: "180px",
    marginRight: "auto",
    marginLeft: "auto",
    zIndex: "2",
    position: "relative",
    backgroundColor: primaryColorLanding,
    "& h1, & h2, & h4, & h6": {
      color: PrimaryFontColorLanding,
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: "24px",
      paddingLeft: "24px",
    },
    [theme.breakpoints.down("xs")]: {
      paddingRight: "16px",
      paddingLeft: "16px",
    },
  },
  title: {
    ...subtitleLandingBold,
    textAlign: "center",
    marginBottom: "0px",
  },
});

export default style;
